const PHOTO_CROP_MIN_POINTS = 3;

export function buildDefaultPhotoCropPoints(width, height) {
  const inset = Math.round(Math.min(width, height) * 0.08);
  const centerX = Math.round(width / 2);
  const centerY = Math.round(height / 2);
  const right = Math.max(inset, width - inset);
  const bottom = Math.max(inset, height - inset);

  return [
    [inset, inset],
    [centerX, inset],
    [right, inset],
    [right, centerY],
    [right, bottom],
    [centerX, bottom],
    [inset, bottom],
    [inset, centerY],
  ];
}

/**
 * Uniform "contain" layout: display box keeps natural aspect ratio.
 * Never stretch from a letterboxed CSS box (width-only scale).
 */
export function buildPhotoCaptureCropLayout(
  naturalWidth,
  naturalHeight,
  maxWidth,
  maxHeight,
) {
  if (!(naturalWidth > 0) || !(naturalHeight > 0)) {
    return null;
  }

  const widthBudget =
    maxWidth > 0 && Number.isFinite(maxWidth) ? maxWidth : naturalWidth;
  const heightBudget =
    maxHeight > 0 && Number.isFinite(maxHeight) ? maxHeight : naturalHeight;

  const scale = Math.min(
    widthBudget / naturalWidth,
    heightBudget / naturalHeight,
    1,
  );

  return {
    naturalWidth,
    naturalHeight,
    displayWidth: naturalWidth * scale,
    displayHeight: naturalHeight * scale,
    scale,
  };
}

function loadImageElement(dataUrl) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = dataUrl;
  });
}

export function canApplyPhotoCrop(points) {
  return Array.isArray(points) && points.length >= PHOTO_CROP_MIN_POINTS;
}

export async function applyPolygonWhiteMask(dataUrl, points) {
  const image = await loadImageElement(dataUrl);
  const width = image.naturalWidth;
  const height = image.naturalHeight;
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext("2d");

  context.fillStyle = "#ffffff";
  context.fillRect(0, 0, width, height);

  if (canApplyPhotoCrop(points)) {
    context.save();
    context.beginPath();
    points.forEach(([x, y], index) => {
      if (index === 0) {
        context.moveTo(x, y);
      } else {
        context.lineTo(x, y);
      }
    });
    context.closePath();
    context.clip();
    context.drawImage(image, 0, 0, width, height);
    context.restore();
  } else {
    context.drawImage(image, 0, 0, width, height);
  }

  return canvas.toDataURL("image/jpeg", 0.92);
}
